import { render } from "./homeData.vue?vue&type=template&id=fa80b262"
import script from "./homeData.vue?vue&type=script&lang=js"
export * from "./homeData.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__